import React from "react";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";
import { Country } from "../../../models/MonetaryZones";
import { Country as AppCountry } from "../../../models/MonetaryZones";

type RegisterStep2Props = {
  formik: any;
  appCountries: AppCountry[];
};

const RegisterStep2: React.FC<RegisterStep2Props> = ({
  formik,
  appCountries,
}) => {
  const selectedCountryTemplate = (option: Country, props: any) => {
    if (option) {
      return <div>{option.name}</div>;
    }

    return <span>{props.placeholder}</span>;
  };

  const countryOptionTemplate = (option: Country) => {
    return <div>{option.name}</div>;
  };

  const handleCountryChange = (event: DropdownChangeEvent) => {
    formik.setFieldValue("countryId", event.value.id);
  };
  return (
    <div className="grid grid-cols-1 gap-4 mt-3">
      {/* Company Name */}
      <div className="field mb-4">
        <FloatLabel>
          <InputText
            id="entreprise_name"
            name="entreprise_name"
            value={formik.values.entreprise_name}
            onChange={formik.handleChange}
            className={`w-full p-2 border rounded-md ${formik.errors.entreprise_name && formik.touched.entreprise_name ? "p-invalid border-red-500" : "border-gray-300"}`}
          />
          <label htmlFor="entreprise_name">Company Name *</label>
        </FloatLabel>
        {formik.errors.entreprise_name && formik.touched.entreprise_name && (
          <Message
            severity="error"
            text={formik.errors.entreprise_name}
            className="input-message"
          />
        )}
      </div>

      {/* Company Type */}
      <div className="field mb-4">
        <FloatLabel>
          <InputText
            id="entreprise_type"
            name="entreprise_type"
            value={formik.values.entreprise_type}
            onChange={formik.handleChange}
            className={`w-full p-2 border rounded-md ${formik.errors.entreprise_type && formik.touched.entreprise_type ? "p-invalid border-red-500" : "border-gray-300"}`}
          />
          <label htmlFor="entreprise_type">Company Type *</label>
        </FloatLabel>
        {formik.errors.entreprise_type && formik.touched.entreprise_type && (
          <Message
            severity="error"
            text={formik.errors.entreprise_type}
            className="input-message"
          />
        )}
      </div>
      <div className="field mb-4">
        <FloatLabel>
          <Dropdown
            id="countryId"
            filter
            name="countryId"
            value={appCountries.find((c) => c.id === formik.values.countryId)}
            onBlur={formik.handleBlur}
            onChange={handleCountryChange}
            options={appCountries}
            optionLabel="name"
            placeholder="Select a Country"
            valueTemplate={selectedCountryTemplate}
            itemTemplate={countryOptionTemplate}
            className={`w-full border rounded-md ${formik.errors.countryId && formik.touched.countryId ? "p-invalid border-red-500" : "border-gray-300"}`}
          />

          <label htmlFor="countryId">Company Location *</label>
        </FloatLabel>
        {formik.errors.countryId && formik.touched.countryId && (
          <Message
            severity="error"
            text={formik.errors.countryId}
            className="input-message"
          />
        )}
      </div>
    </div>
  );
};

export default RegisterStep2;
